module.exports = __webpack_public_path__ + "img/mobile-menu-dark.ee34c175.svg";